import {useApiUrl} from "@refinedev/core";
import {RefObject, useContext, useEffect, useLayoutEffect, useState} from "react";
import {SidebarContext, SidebarContextProps} from "./context/sidebar-context";
import {FileEntity} from "./sdk";

export const useFileEntityUrl = (
  file: FileEntity | number | string | undefined | null
) => {
  const apiUrl = useApiUrl();

  if (!file) {
    return;
  }
  if ((file as FileEntity)?.id) {
    return `${apiUrl}/files/${(file as FileEntity).id}`;
  } else {
    return `${apiUrl}/files/${file}`;
  }
};

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowDimensions;
};

export const useAutoShrinkText = (
  ref: RefObject<HTMLElement | null>,
  maxFontSize: number,
  maxLines: number,
  lineHeight = 1.1,
  stepSize = 8
) => {
  const [fontSize, setFontSize] = useState(maxFontSize);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    let size = maxFontSize;
    el.style.fontSize = `${size}px`;

    while (el.scrollHeight > size * lineHeight * maxLines + 1 && size > stepSize) {
      size -= stepSize;
      el.style.fontSize = `${size}px`;
    }

    setFontSize(size);
  });

  return fontSize;
};

export const useSidebar = (): SidebarContextProps => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};
